export default __webpack_public_path__ + "static/media/Tralexho-X.8aa9614c.png";